import { render } from "./Cotizaciones.vue?vue&type=template&id=70b2abc4&scoped=true"
import script from "./Cotizaciones.vue?vue&type=script&lang=js"
export * from "./Cotizaciones.vue?vue&type=script&lang=js"

import "./Cotizaciones.vue?vue&type=style&index=0&id=70b2abc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b2abc4"]])

export default __exports__